import React, { Fragment, useRef, useState } from "react";
import Slider from "react-slick";
import ModalVideos from "../ModalVideo/ModalVideos";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img0 from "../../assets/images/logo/Client/Satya.webp";
import img1 from "../../assets/images/logo/Client/Akshay.webp";
import img2 from "../../assets/images/logo/Client/Varun.webp";
import img3 from "../../assets/images/logo/Client/Juned.webp";

const SliderContent = [
  {
    img: img0,
    plogo: "Plogo-15",
    title: "Nirwana Microsystem",
    desc: "Always available to answer our queries. Very knowledgeable about the services they provide. Would recommend to anyone !",
    text: "Director",
    arrow: "icon_14",
  },
  {
    img: img1,
    plogo: "Plogo-4",
    title: "Its For You Private Limited",
    desc: "Note G Proved to be a professional service provider from the outset. We appreciate . . .",
    text: "Founder & Director",
    arrow: "icon_14",
  },
  {
    img: img2,
    plogo: "Plogo-3",
    title: "Prophecis Technologies Private Limited",
    desc: "The solutions provided by NoteG Technologies have satisfied all project requirements . . .",
    text: "Vice President",
    arrow: "icon_14",
  },
  {
    img: img3,
    plogo: "Plogo-2",
    title: "Trioca Technologies Private Limited",
    desc: "Appreciation to NoteG team for the outstanding job they did for us. The project is . . .",
    text: "Director",
    arrow: "icon_14",
  },
];

const settings2 = {
  arrow: true,
  dots: false,
  infinite: true,
  speed: 100,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    // {
    //     breakpoint: 575,
    //     settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1
    //     }
    // }
  ],
};

const TestimonialTwo = () => {
  const [isOpen, setOpen] = useState(false);

  const openModal = () => {
    setOpen(!isOpen);
  };

  return (
    <Fragment>
      <ModalVideos isOpen={isOpen} onClick={openModal} />

      <Slider className="feedback_slider_two" {...settings2}>
        {SliderContent.map((val, i) => (
          <div className="item" key={i}>
            <div className="feedback-block-two d-sm-flex">
              <div className="img-meta">
                <img src={val.img} alt="images" />
              </div>
              <div className="text-wrapper">
                <div className="camp-name">{val.title}</div>
                <p>{val.desc}</p>
                <a className="read-btn d-flex align-items-center justify-content-between">
                  <span>{val.text}</span>
                  <img
                    src={`images/icon/${val.arrow}.svg`}
                    alt="icon"
                    className="arrow"
                  />
                </a>
              </div>
              {/* /.text-wrapper */}
            </div>
            {/* /.feedback-block-two */}
          </div>
        ))}
      </Slider>
      {/* /.feedback_slider_two */}
    </Fragment>
  );
};

export default TestimonialTwo;
